<template>
  <section class="medical-exam-request">
    <header class="medical-exam-request__header">
      <img src="@/assets/img/home/logo_web.png" class="medical-exam-request__logo" />

      <h1 class="medical-exam-request__title">
        Exame Médico
      </h1>
    </header>

    <article class="medical-exam-request__body">
      <dr-loader
        v-if="ui.isLoading && !ui.hasLoaded"
        size="lg"
        class="medical-exam-request__loading"
      />

      <p
        v-if="!ui.isLoading && ui.hasLoaded && ui.hasError"
        class="medical-exam-request__error"
      >
        O pedido de exame não foi encontrado ou seu link de acesso expirou.
        <br>
        Você pode visualizar seu exame no aplicativo Dr. Conecta ou gerar um
        novo link de acesso, também pelo aplicativo.
      </p>

      <object
        v-show="!ui.isLoading && ui.hasLoaded && !ui.hasError && ui.isPdf"
        ref="embed_container"
        :data="fileData"
        class="medical-exam-request__file"
        type="application/pdf"
        height="100%"
        width="100%"
      />

      <img
        v-if="!ui.isLoading && ui.hasLoaded && !ui.hasError && !ui.isPdf"
        class="medical-exam-request__file medical-exam-request__file--img"
        :src="fileData"
      />
    </article>
  </section>
</template>

<script>
export default {
  name: 'DrMedicalExamRequest',

  data () {
    return {
      fileData: null,
      ui: {
        isLoading: false,
        hasLoaded: false,
        hasError: false,
        isPdf: false
      }
    }
  },

  computed: {
    hash () {
      return this.$route.query.hash || ''
    }
  },

  created () {
    this.ui.isLoading = false
    this.ui.hasLoaded = false
    this.ui.hasError = false
    this.ui.isPdf = false
  },

  mounted () {
    this.getExam()
  },

  destroyed () {
    this.ui.isLoading = false
    this.ui.hasLoaded = false
    this.ui.hasError = false
    this.ui.isPdf = false
  },

  methods: {
    getExam () {
      this.ui.hasError = false
      this.ui.isLoading = true
      this.ui.isPdf = false
      this.fn_SHOW_PROGRESS()

      this.$http
        .get(`/user/medical_exam/public?hash=${this.hash}`, { responseType: 'blob' })
        .then((res) => {
          const { headers, data } = res
          if (/pdf/gi.test(headers['content-type'])) {
            this.resizeEmbedContainer()
            this.ui.isPdf = true
          }

          this.fileData = this.createFile(data, headers['content-type'])
        })
        .catch((err) => {
          console.log('err is', err)
          this.ui.hasError = true
        })
        .finally(() => {
          this.ui.isLoading = false
          this.ui.hasLoaded = true
          this.fn_HIDE_PROGRESS()
        })
    },

    createFile (raw, type) {
      const blob = new Blob([raw], { type: type })
      return URL.createObjectURL(blob)
    },

    resizeEmbedContainer () {
      const embedContainer = this.$el.querySelector('.medical-exam-request__body')
      const embed = this.$refs['embed_container']
      embed.style.height = `${embedContainer.offsetHeight}px`
    }
  }
}
</script>
